import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import ComplaintsWrapper from "./ComplaintsWrapper";
import ProtectedRoute from "../../../../components/util-components/ProtectedRoute";

const PARENT_URL = "/cms/finance/complaints";

// Wrapper component to extract companyType parameter
const ComplaintsWrapperWithParams = () => {
  const { companyType } = useParams();
  return (
    <ProtectedRoute routeKey={`shop-complaints-${companyType}`}>
      <ComplaintsWrapper />
    </ProtectedRoute>
  );
};

const Complaints = () => {
  return (
    <Routes>
      <Route path="/:companyType" element={<ComplaintsWrapperWithParams />} />
      <Route path="" element={<Navigate to={`${PARENT_URL}/chefs-farm`} replace />} />
    </Routes>
  );
};

export default Complaints;
